export const QueryKey = {
	GET_PASSWORD_RULES: 'GetPasswordRules',
	GET_SECURITY_QUESTIONS: 'GetSecurityQuestions',
	GET_RESET_PASSWORD_QUESTION: 'GetResetPasswordQuestion',
	GET_USERNAME_RULES: 'GetUsernameRules',
	GET_EMAIL_VERIFICATION_STATUS: 'GetEmailVerificationStatus',
	GET_EMAIL_FROM_ACCOUNT: 'GetEmailFromAccount',
	GET_MFA_OTP: `GetMFAOtp`,
	GET_ENFORCE_MFA_OTP: `GetEnforceMFAOtp`,
};
